/*
 * What the 3D package prints on its label. Built from a product row, so a product renamed in the CMS
 * gets a new label automatically. Kept free of 3D code so pages can import it cheaply.
 */

export type PackageKind = 'tin' | 'bottle'

export type PackageLabel = {
    name: string
    latin: string | null
    category: string | null
    categorySlug: string | null
}

export const packageKindFor = (categorySlug: string | null): PackageKind => {
    return categorySlug === 'essential-oils' ? 'bottle' : 'tin'
}

export const toPackageLabel = (product: {
    name: string
    scientific_name: string | null
    category_name: string | null
    category_slug: string | null
}): PackageLabel => ({
    name: product.name,
    latin: product.scientific_name,
    category: product.category_name,
    categorySlug: product.category_slug
})
